import React from 'react';
import './contactUs.css';
import right_arrow from './images/right_arrow.png'
const ContactUs=()=>{
    return(
        <div style={{paddingTop:100}}>
            <div className='grid_container_contact_us'>
                <div className='grid_itemr_contact_us'>
                    <div  style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                    }}>
                        <img src={right_arrow} style={{
                            height:40,
                            filter:'invert(66%) sepia(52%) saturate(6170%) hue-rotate(159deg) brightness(92%) contrast(101%)'
                        }}/>
                        <span>&nbsp;&nbsp;Corporate Office
                        SuperSeva Services Pvt Ltd</span>
                    </div>
                    <div>
                        <span>
                        #1245, Sector-2, 27th Main Rd
                        HSR Layout, Somasundarapalya
                        Near Power Station
                        Bengaluru, Karnataka 560102
                        </span>
                    </div>
                </div>
                <div className='grid_itemr_contact_us'>
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                    }}>
                        <img src={right_arrow} style={{
                            height:40,
                            filter:'invert(66%) sepia(52%) saturate(6170%) hue-rotate(159deg) brightness(92%) contrast(101%)'
                        }}/>
                        <span>&nbsp;&nbsp;Branch Office : Mumbai</span>
                    </div>
                    <div>
                        <span>
                            S-29, Second Floor, Sej Plaza,
                            Next to Nutan Public School, Marve Road, Malad West, Mumbai–400064
                        </span>
                    </div>
                </div>
                <div className='grid_itemr_contact_us'>
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                    }}>
                        <img src={right_arrow} style={{
                            height:40,
                            filter:'invert(66%) sepia(52%) saturate(6170%) hue-rotate(159deg) brightness(92%) contrast(101%)'
                        }}/>
                        <span>&nbsp;&nbsp;Branch Office : Pune</span>
                    </div>
                    <div>
                        <span>
                            Office No 7, Satyam Arcade
                            Near Vimaantal Police Station, Ramwadi,Pune- 411 014
                        </span>
                    </div>
                </div>
                <div className='grid_itemr_contact_us'>
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                    }}>
                        <img src={right_arrow} style={{
                            height:40,
                            filter:'invert(66%) sepia(52%) saturate(6170%) hue-rotate(159deg) brightness(92%) contrast(101%)'
                        }}/>
                        <span>&nbsp;&nbsp;Branch Office : Chennai</span>
                    </div>
                    <div>
                        <span>
                            New no:64, Old no: 100, Bazaar Road, Next TNSC bank, Saidapet, Chennai – 600 015
                        </span>
                    </div>
                </div>
                <div className='grid_itemr_contact_us'>
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                    }}>
                        <img src={right_arrow} style={{
                            height:40,
                            filter:'invert(66%) sepia(52%) saturate(6170%) hue-rotate(159deg) brightness(92%) contrast(101%)'
                        }}/>
                        <span>&nbsp;&nbsp;Branch Office: Delhi NCR</span>
                    </div>
                    <div>
                        <span>
                            Office No. 807 ,Eros Apartments 56, Nehru Place,New Delhi-110019
                        </span>
                    </div>
                </div>
                <div className='grid_itemr_contact_us'>
                    <div style={{
                        display:'flex',
                        justifyContent:'flex-start',
                        alignItems:'center'
                    }}>
                        <img src={right_arrow} style={{
                            height:40,
                            filter:'invert(66%) sepia(52%) saturate(6170%) hue-rotate(159deg) brightness(92%) contrast(101%)'
                        }}/>
                        <span>&nbsp;&nbsp;Branch Office : Hyderabad</span>
                    </div>
                    <div>
                        <span>
                            6-2-952/1/F1,8th Lane , Khairtabad,
                            Hyderabad – 500 029
                        </span>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default ContactUs